<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template v-slot:fileType="{item}">
                <i :class="getFileIcon(item.extension)" class="fa-1x fa-lg mt-3"></i>
            </template>
            <template slot="created_at" slot-scope="{ item }">{{ item.created_at | datetime }}</template>
            <template slot="expiration" slot-scope="{ item }">{{ item.expiration | date }}</template>
            <template slot="actions" slot-scope="{ item }">
                <b-button
                    size="sm"
                    v-if="!user.profile.client_side"
                    title="Editar"
                    variant="primary"
                    @click="updateFile(item)"
                >
                    <i class="fa fa-pencil"></i>
                </b-button>
                <app-btn-confirm
                    v-if="!user.profile.client_side"
                    variant="danger"
                    @confirm="removeFile(item.id)"
                    title="Eliminar registro"
                    :disabled="inProgress"
                >
                    <i class="fa fa-trash"></i>
                </app-btn-confirm>
                <label v-if="user.profile.client_side">Sin acciones</label>
            </template>
            <template slot="file_name" slot-scope="{ item }">
                <b-button variant="link" @click="downloadFile(item)">
                    {{item.name}}
                    <i class="fa fa-download"></i>
                </b-button>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: [Array, Object],
            default: '',
        },
    },
    data() {
        return {
            fields,
            venueUsers: [],
            selectedVenueUsers: [],
            selectedVenue: '',
            clientUsers: [],
            isLoaded: false,
            fileTypes,
        }
    },
    methods: {
        onChangePage(page) {
            this.$emit('change-page', page)
        },
        updateFile(data) {
            this.$emit('update-file', data)
        },
        removeFile(id) {
            this.$emit('remove-file', id)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        downloadFile(item) {
            window.open(`web/v1/file-management/${item.id}/download`, '_blank')
        },
        getFileIcon(ext) {
            return ext.toLowerCase() in this.fileTypes
                ? this.fileTypes[ext.toLowerCase()]
                : 'fa fa-file'
        },
    },
}

const fields = [
    {
        key: 'fileType',
        label: 'Tipo',
        filter: false,
    },
    {
        key: 'file_name',
        label: 'Archivo',
        filter: true,
    },
    {
        key: 'name',
        label: 'Nombre',
        filter: true,
    },
    {
        key: 'expiration',
        label: 'Expiración',
        filter: true,
    },
    {
        key: 'file_type.name',
        label: 'Tipo de archivo',
    },
    {
        key: 'created_at',
        label: 'Creado el',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]

const fileTypes = {
    pdf: 'fa fa-file-pdf-o',
    jpg: 'fa fa-picture-o',
    jpeg: 'fa fa-picture-o',
    png: 'fa fa-picture-o',
    gif: 'fa fa-picture-o',
    tiff: 'fa fa-picture-o',
    xls: 'fa fa-file-excel-o',
    xlsx: 'fa fa-file-excel-o',
    pptx: 'fa fa-file-powerpoint-o',
    docx: 'fa fa-file-word-o',
    txt: 'fa fa-file-text',
}
</script>
